<template>
    <div class="popover-copy">
        <div class="popover-header">
            <span class="pr-30">Produkt <i>{{product.name}}</i></span>
            <button type="button" aria-label="Close" class="close"><span aria-hidden="true" v-close-popover>×</span>
            </button>
        </div>
        <div class="popover-body">
                <scrollable-select @change="selectedDay = $event.value">
                  <template v-slot:options>
                    <option v-for="day in availableDays" :value="day">
                      <template v-if="MENU_MODE">
                        {{day.name()}}
                      </template>
                      <template v-else>
                        {{ 'app.day' | trans }} {{ getDayIndexById(day.id) + 1 }}
                      </template>
                    </option>
                  </template>
                </scrollable-select>
            <div v-if="selectedDay">
                <label>Posiłek...</label><br>
                <select v-model="selectedPlan" class="form-control input-sm">
                    <option v-for="plan in availablePlans" :value="plan">
                        {{plan.name}}
                    </option>
                </select>
            </div>
        </div>
        <div class="popover-footer">
            <button :disabled="selectedDay === null || selectedPlan === null" class="btn btn-success" @click="copy" v-close-popover>Kopiuj</button>
            <button class="btn btn-default" v-close-popover>Zamknij</button>
        </div>
    </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex';
  import {trans} from '../../app';
  import { copyProduct } from '../../services/CopyMenuDay';

  export default {
    props: [
      'dayId', 'planId', 'productId',
    ],
    created() {
      this.plan = this.getPlan(this.dayId, this.planId);
      this.product = this.plan.findProduct(this.productId, 'id');
    },
    data() {
      return {
        plan: null,
        selectedDay: null,
        selectedPlan: null,
        mode: 'add',
      };
    },
    computed: {
      ...mapState({
        menu(state) {
          return state.menu;
        },
        days(state) {
          if (state.menu.schema)
            return state.menu.schema.days;
        },
      }),
      ...mapGetters(['MENU_MODE', 'getDayIndexById']),
      availableDays() {
        return this.days;
      },
      availablePlans() {
        return this.selectedDay.plans.filter(p => !p.findProduct(this.product.externalId));
      },
    },
    methods: {
      getPlan(dayId, planId) {
        return this.$store.getters.getDayById(dayId).getPlan(planId);
      },
      getDay(dayId) {
        return this.$store.getters.getDayById(dayId);
      },
      copy() {
        this.selectedPlan.addProduct(copyProduct(this.product));
        this.$toast.success(trans('app.product_copied'));
        this.selectedDay = null;
      },
    },
  };
</script>
